import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import OverviewTab from '../components/analytics/OverviewTab';
import FloorDepthTab from '../components/analytics/FloorDepthTab';
import HoldersTab from '../components/analytics/HoldersTab';

const Analytics = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Overview', component: OverviewTab },
    { id: 'floor-depth', label: 'Floor & Depth', component: FloorDepthTab },
    { id: 'holders', label: 'Holders', component: HoldersTab }
  ];

  // Handle URL hash changes
  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash && tabs.find(tab => tab.id === hash)) {
      setActiveTab(hash);
    }
  }, [location.hash]);

  // Handle tab changes
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    navigate(`/analytics#${tabId}`, { replace: true });
  };

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component || OverviewTab;

  return (
    <div className="analytics-page">
      <div className="analytics-header">
        <h1 className="analytics-title">Analytics</h1>
        <p className="analytics-subtitle">Market insights and trading data</p>
      </div>

      <div className="analytics-tabs">
        <div className="analytics-tab-list" role="tablist">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`analytics-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => handleTabChange(tab.id)}
              role="tab"
              aria-selected={activeTab === tab.id}
              aria-controls={`panel-${tab.id}`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="analytics-content">
        <div
          id={`panel-${activeTab}`}
          role="tabpanel"
          aria-labelledby={`tab-${activeTab}`}
        >
          <ActiveComponent />
        </div>
      </div>
    </div>
  );
};

export default Analytics;
